import { t } from 'i18next';
import * as yup from 'yup';

import { Label } from '~hooks/useLabels/models';
import { DEFAULT_PALETTE_COLOR, hexColorYupField } from '~utils/colors';

export const labelSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  color: hexColorYupField(),
});

export type LabelDto = yup.InferType<typeof labelSchema>;
export type LabelDtoAsyncError = {
  field: keyof LabelDto;
  message: string;
};

export const setLabelSchemaDefaultValues = (label?: Label): LabelDto => {
  return {
    name: label?.name ?? '',
    color: label?.color ?? DEFAULT_PALETTE_COLOR,
  };
};
